import { render, staticRenderFns } from "./SimpleProfileSearch.vue?vue&type=template&id=61eeb45a&scoped=true&"
import script from "./SimpleProfileSearch.vue?vue&type=script&lang=ts&"
export * from "./SimpleProfileSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleProfileSearch.vue?vue&type=style&index=0&id=61eeb45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eeb45a",
  null
  
)

export default component.exports